import React from 'react';
import { FaPhoneAlt } from 'react-icons/fa';
import { Card, Text, Input } from 'v3/components';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { getPhoneMask } from 'v3/utils/functions';

const Contact = ({ data, setData, errors, loading }) => {

  return (
    <Card
      header={
        <Text color="#464E5F" type="header">
          Contatos
        </Text>
      }
    >
      <Row className="form">
        <Col lg={6} md={6} xs={12}>
          <Input
            icon={<FaPhoneAlt color="#464E5F" />}
            value={data?.phone}
            onChange={event => setData({ ...data, phone: event.target.value })}
            masked
            mask={getPhoneMask('BR')}
            label="Telefone (cooperplace) *"
            error={errors?.['contact.phone']}
            disabled={loading}
          />
        </Col>
        <Col lg={6} md={6} xs={12}>
          <Input
            label="Email *"
            value={data?.email}
            onChange={event => setData({ ...data, email: event.target.value })}
            error={errors?.['contact.email']}
            disabled={loading}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default Contact;
